import {
  Button,
  Badge,
  BadgeGroup,
  NavBar,
  Row,
  Col,
  Card,
  Tag,
  Icon,
  Cell,
  CellGroup,
  Panel,
  Dialog,
  Swipe,
  Toast,
  SwipeItem,
  SubmitBar,
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  AddressEdit,
  Slider,
  Stepper,
  Steps,
  Pagination,
  Area,
  // Lazyload,
  PullRefresh,
  Actionsheet
} from 'vant'

// 基础元件
import KNoData from './k/k-no-data' // 无数据
import KDivider from './k/k-hr' // 水平分隔线或块
import KLoading from './k/k-loading'
import KTime from './k/k-time'
import KDlg from './k/k-dlg'
import KChk from './k/k-chk'
import KBtn from './k/k-btn'
import KNum from './k/k-num'
import KRate from './k/k-rate'
import KMoney from './k/k-money'
import KVideo from './k/k-video'
import KAudio from './k/k-audio'
import KPanel from './k/k-panel'
import KUser from './k/k-user'
import KBadgeTeacher from './k/k-badge-teacher.vue'
import KBadgeUser from './k/k-badge-level.vue'
import KStar from './k/k-star'
import KTag from './k/k-tag'
import KCardCourse from './k/k-card-course'
import KCardGoods from './k/k-card-goods'

// wz
import WZCommentItem from './wz/wz-comment-item'
import WZCommentPost from './wz/wz-comment-post'
import WZCommentList from './wz/wz-comment-list'
// import PPLogin from './passport/pp-login'
// import PPRegister from './passport/pp-register'
// import PPNickEdit from './passport/pp-nick-edit'
// import PPOther from './passport/pp-other'

// xs
// import XSMod from './xs/xs-mod' // 通用模块基本结构
// import XSLogin from './xs/xs-login'
// import XSRegister from './xs/xs-register'
// import XSNickEdit from './xs/xs-nick-edit'
// import XSNeedLogin from './xs/xs-need-login'
// import XSTopSlider from './xs/xs-top-slider'

// import XSCourseCard from './xs/course/course-card'
// import XSCourseOrderCard from './xs/course/course-order-card'
// import XSCourseDetail from './xs/course/course-detail'
// import XSCourseWares from './xs/course/course-wares'
// import XSCourseChat from './xs/course/course-chat'
// import XSCoursePlayer from './xs/course/course-player'
// import XSCourseInfo from './xs/course/course-info'
// // import XSCourseVideo from './xs/course/course-video'
// // import XSCourseAudio from './xs/course/course-audio'

// import XSTeacherCard from './xs/teacher/teacher-card'
// import XSTeacherSaleItem from './xs/teacher/teacher-sale-item'

// import XSHomeSect from './xs/home/home-sect'
// // import XSHomeIcons from './xs/home/home-icons'
// import XSSlideList from './xs/home/slide-list'
// import XSHomeRecommendVideos from './xs/home/recommend-videos'
// import XSCourseListItem from './xs/course/course-list-item'

// import XSMyBannerLink from './xs/my/banner-link'
// import XSTeacherTools from './xs/my/teacher-tools'

//MQTT
// import MQList from './mqtt/mqtt-list'
// import MQPost from './mqtt/mqtt-post'
// import MQListItem from './mqtt/list/mq-list-item'
// import MQEmoji from './mqtt/list/mq-emoji'
// import MQImgbox from './mqtt/list/mq-imgbox'
// import MQUploadImg from './mqtt/list/mq-upload-img'

import { isArray, forEach, isPlain } from '../utils/base'

export default Vue => {
  function register(O) {
    if (isArray(O)) {
      forEach(O, o => {
        if (!o.name) {
          throw o
        }
        Vue.component(o.name, o)
      })
    } else if (isPlain(O)) {
      forEach(O, (o, name) => {
        Vue.component(name, o)
      })
    }
  }
  register([
    Button,
    Badge,
    BadgeGroup,
    Row,
    Col,
    Card,
    Tag,
    Icon,
    Toast,
    Cell,
    CellGroup,
    Swipe,
    SwipeItem,
    Dialog,
    GoodsAction,
    GoodsActionBigBtn,
    GoodsActionMiniBtn,
    SubmitBar,
    NavBar,
    Panel,
    Tab,
    Tabs,
    Tabbar,
    TabbarItem,
    Slider,
    Stepper,
    Steps,
    Pagination,
    Area,
    AddressEdit,
    // Lazyload, // 该组件没有 name 值
    PullRefresh,
    Actionsheet,

    // 基础元件
    KNoData,
    KDivider,
    KLoading,
    KTime,
    KDlg,
    KChk,
    KBtn,
    KNum,
    KRate,
    KMoney,
    KVideo,
    KAudio,
    // KLiveVhall,
    KPanel,
    KUser,
    KBadgeTeacher,
    KBadgeUser,
    KStar,
    KTag,
    KCardCourse,
    KCardGoods,

    // 王者组件
    WZCommentItem,
    WZCommentList,
    WZCommentPost
    // PPLogin,
    // PPRegister,
    // PPNickEdit,
    // PPOther,

    // 玄商组件
    // XSMod,
    // XSTabbar,
    // XSLogin,
    // XSRegister,
    // XSNickEdit,
    // XSNeedLogin,

    // // 首页
    // XSHomeSect,
    // // XSHomeIcons,
    // XSTopSlider,
    // XSSlideList,
    // XSHomeRecommendVideos,
    // XSCourseListItem,

    // 课程
    // XSCourseCard,
    // XSCourseOrderCard,
    // XSCourseDetail,
    // XSCourseWares,
    // XSCourseChat,
    // XSCoursePlayer,
    // XSCourseInfo,
    // // XSCourseVideo,
    // // XSCourseAudio,

    // // 老师
    // XSTeacherCard,
    // XSTeacherSaleItem,

    // // 我的
    // XSMyBannerLink,
    // XSTeacherTools,

    // 商城相关
    // XSProdCard,
    // XSProdList,
    // XSCopyright

    // //MQTT
    // MQList,
    // MQPost,
    // MQListItem,
    // MQEmoji,
    // MQImgbox,
    // MQUploadImg
  ])
}
